<template>
  <div class="leilao-ativo">
    <!-- Titulo Box -->
    <v-container
      class="mt-6 mb-6"
      fluid
    >
      <v-row>
        <v-col
          class="v-col--video fill-height"
          lg="6"
        >
          <Slider
            :assets="lot.assets"
          ></Slider>
        </v-col>
        <Bids/>
      </v-row>
    </v-container>
    <ProductVideo />
  </div>
</template>
<script>
import RegisterMixin from '@/mixins/RegisterMixin';
import Slider from '@/views/leilao/components/Slider';
import Bids from '@/views/leilao/components/Bids';
import ProductVideo from '@/views/leilao/components/ProductVideo';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Slider,
    Bids,
    ProductVideo,
  },
  mixins: [RegisterMixin],
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      focusVideo: false,
    };
  },
  computed: {
    ...mapState('Data/Auctions', [
      'auction',
      'lot',
    ]),
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    // UserService.retriverProfileInfo();
    this.$bus.on(this.$events.GET_PARTNER, () => {
      // UserService.retriverProfileInfo();
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';

.v-col {
  &--video {
    position: relative;
  }
}
.v-card {
  &--youtube {
    background: none;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
    transition: all 300ms ease-in-out;
    &--full {
      top: 0px;
      right: 0px;
      width: 100% !important;
      height: 100% !important;
      transition: all 300ms ease-in-out;
    }
  }
}

.leilao-ativo {
  @media (max-width: $md) {
    .container {
      .row {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
